var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 4.23858 4.23858 2 7 2H41C43.7614 2 46 4.23858 46 7V41C46 43.7614 43.7614 46 41 46H7C4.23858 46 2 43.7614 2 41V7ZM7 6C6.44771 6 6 6.44772 6 7V41C6 41.5523 6.44772 42 7 42H41C41.5523 42 42 41.5523 42 41V7C42 6.44771 41.5523 6 41 6H7Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 30C2 28.8954 2.89543 28 4 28H13.8377C15.9899 28 17.9006 29.3772 18.5811 31.4189L19.2136 33.3162C19.3497 33.7246 19.7318 34 20.1623 34H27.8377C28.2682 34 28.6503 33.7246 28.7864 33.3162L29.4189 31.4189C30.0994 29.3772 32.0101 28 34.1623 28H44C45.1046 28 46 28.8954 46 30V40.9966C46 43.7603 43.7619 46 40.9935 46H7.0065C4.24445 46 2 43.7652 2 40.9966V30ZM6 32V40.9966C6 41.5501 6.44766 42 7.0065 42H40.9935C41.5535 42 42 41.5504 42 40.9966V32H34.1623C33.7318 32 33.3497 32.2754 33.2136 32.6838L32.5811 34.5811C31.9006 36.6228 29.9899 38 27.8377 38H20.1623C18.0101 38 16.0994 36.6228 15.4189 34.5811L14.7864 32.6838C14.6503 32.2754 14.2682 32 13.8377 32H6Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13C11 11.8954 11.8954 11 13 11H35C36.1046 11 37 11.8954 37 13C37 14.1046 36.1046 15 35 15H13C11.8954 15 11 14.1046 11 13Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21C11 19.8954 11.8954 19 13 19H35C36.1046 19 37 19.8954 37 21C37 22.1046 36.1046 23 35 23H13C11.8954 23 11 22.1046 11 21Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.3ffe1931.svg";
export { ForwardRef as ReactComponent };